import {
    GET_LINKS,
    GET_LINKS_SUCCESS,
    GET_LINKS_FAILURE,
    SET_ROUTE_PATH_FOR_LINKS_UNSAVED_CHANGES_POP_UP,
    SET_LINKS_UNSAVED_CHANGES_POP_UP,
} from '../actions';

const initialState = {
    loading: false,
    linkList: [],
    routePathForLinksUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    unsavedLinksChangesPopUp: false,
};
const LinksReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LINKS:
            return {
                ...state,
                loading: true,
            };
        case GET_LINKS_SUCCESS:
            return {
                ...state,
                loading: false,
                linkList: action.payload.webLinks,
            };
        case GET_LINKS_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SET_LINKS_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedLinksChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_LINKS_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForLinksUnsavedChangesPopUp: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default LinksReducer;
